import { useEffect } from "react";

const ScrollAnimation = () => {
  useEffect(() => {
    const handleScrollAnimation = () => {
      const wt = window.scrollY;
      const elements = document.querySelectorAll(".init");

      if (!elements.length) return; // 요소가 없으면 종료

      elements.forEach((element) => {
        const st =
          element.getBoundingClientRect().top +
          window.scrollY -
          window.innerHeight +
          window.innerHeight / 4;
        if (wt > st) {
          element.classList.add("animate");
        } else {
          element.classList.remove("animate");
        }
      });
    };

    const handleScrollHeader = (e) => {
      const header = document.querySelector("#header");
      const container = document.querySelector("#container");

      if (!header || !container) return; // 요소가 없으면 종료

      if (e.wheelDelta > 0) {
        header.classList.remove("down");
        header.classList.add("up");
        container.classList.remove("down");
        container.classList.add("up");
      } else {
        header.classList.remove("up");
        header.classList.add("down");
        container.classList.remove("up");
        container.classList.add("down");
      }
    };

    handleScrollAnimation();

    window.addEventListener("scroll", handleScrollAnimation);
    window.addEventListener("mousewheel", handleScrollHeader);

    return () => {
      window.removeEventListener("scroll", handleScrollAnimation);
      window.removeEventListener("mousewheel", handleScrollHeader);
    };
  }, []);

  return null; // 이 컴포넌트는 UI를 렌더링하지 않습니다.
};

export default ScrollAnimation;
